import {
  TOGGGLE_LID_MC,
  OPEN_MODAL_MC,
  CLOSE_MODAL_MC,
  SET_MODAL_VIEW_MC,
  SET_RPM_MC,
  SET_TIMER_MC,
  ON_DROP_SLOT_MC,
  ON_RUN_CENTRIFUGE_MC,
  ON_STOP_CENTRIFUGE_MC,
  ANIMATION_PLAYBACK_COMPLETE_MC,
  ON_DROP_CENTRIFUGE_MC,
  REMOVE_SLOT_ITEMS_MC,
} from "../Redux.constants";

export const toggleLidMC = (payload) => {
  return { type: TOGGGLE_LID_MC, payload }
}

export const openModalMC = (payload) => {
  return { type: OPEN_MODAL_MC, payload }
}

export const closeModalMC = (payload) => {
  return { type: CLOSE_MODAL_MC, payload }
}

export const setModalViewMC = (payload) =>{
  return { type: SET_MODAL_VIEW_MC, payload }
}

export const setRPMMC = (payload) =>{
  return { type: SET_RPM_MC, payload }
}

export const setTimerMC = (payload) => {
  return { type: SET_TIMER_MC, payload }
}

export const animationPlaybackCompleteMC = (payload) =>{
  return { type: ANIMATION_PLAYBACK_COMPLETE_MC, payload }
}

export const onDropSlotMC = (payload) => {
  return { type: ON_DROP_SLOT_MC, payload }
}

export const onRunCentrifugeMC = (payload) => {
  return { type: ON_RUN_CENTRIFUGE_MC, payload }
}

export const onStopCentrifugeMC = (payload) => {
  return { type: ON_STOP_CENTRIFUGE_MC, payload }
}

export const removeSlotItemsMC = (payload) =>{
  return { type: REMOVE_SLOT_ITEMS_MC, payload}
}

export const onItemDropCentrifugeMC = (payload) => {
  return { type: ON_DROP_CENTRIFUGE_MC, payload }
}



//Creates new Tip Box and assigns ID and type
export const createMicrocentrifuge = (data) => {
  //data = {id, type}
  return { type: "CREATE_MICROCENTRIFUGE", payload: data }
}
export const toggleMicrocentrifugeLid = (data) => {
  return { type: "MICROCENTRIFUGE_TOGGLE_LID_STATE", payload: data }
}


export const toggleMicrocentrifugeControlsModal = (data) => {
  return { type: "MICROCENTRIFUGE_TOGGLE_CONTROLS_MODAL", payload: data }
}
export const toggleMicrocentrifugeTooltipsControls = (data) => {
  return { type: "MICROCENTRIFUGE_TOGGLE_TOOLTIP_CONTROLS", payload: data }
}
export const toggleMicrocentrifugeBalanceTubeModal = (data) => {
  return { type: "MICROCENTRIFUGE_TOGGLE_BALANCE_TUBE_MODAL", payload: data }
}
export const setMicrocentrifugeRPM = (data) => {
  return { type: "MICROCENTRIFUGE_UPDATE_RPM", payload: data }
}
export const setMicrocentrifugeTime = (data) => {
  return { type: "MICROCENTRIFUGE_UPDATE_TIME", payload: data }
}
export const ejectMicrocentrifugeTubes = (data) => {
  return { type: "MICROCENTRIFUGE_EJECT_TUBES", payload: data }
}
export const ejectMicrocentrifugeRotors = (data) => {
  return { type: "MICROCENTRIFUGE_EJECT_ROTORS", payload: data }
}
export const onMicrocentrifugeTubeDrop = (data) => {
  return { type: "MICROCENTRIFUGE_TUBE_DROP", payload: data }
}
export const checkMicrocentrifugeBalance = (data) => {
  return { type: "MICROCENTRIFUGE_SET_TUBES_BALANCED", payload: data }
}
export const onMicrocentrifugeInsertItem = (data) => {
  return { type: "MICROCENTRIFUGE_INSERT_ITEM", payload: data }
}
export const onMicrocentrifugeInsertRotor = (data) => {
  return { type: "MICROCENTRIFUGE_INSERT_ROTOR", payload: data }
}
export const onMicrocentrifugeRun = (data) => {
  return { type: "MICROCENTRIFUGE_RUN", payload: data }
}
